import {
  type DocumentData,
  type QueryConstraint,
  where,
} from "firebase/firestore";
import { firestoreApi } from "../../core/apis/firestoreApi";
import BaseApi from "../../core/BaseApi";
import {
  BusinessPlanModel,
  type BusinessPlanModelData,
} from "./BusinessPlanModel";

export default class BusinessPlansApi extends BaseApi<
  BusinessPlanModel,
  BusinessPlanModelData
> {
  /* PRIVATE APIS */

  async getPlansForCustomer(customerUid: string) {
    const qs: QueryConstraint[] = [
      where("customerInfo.uid", "==", customerUid),
    ];

    const querySnapshots = await firestoreApi.queryDocuments(this.db, ...qs);

    const models: BusinessPlanModel[] = [];

    querySnapshots.forEach((querySnapshot) => {
      models.push(this.fromFirestore(querySnapshot));
    });
    this.store.load(models);
  }

  /* NEEDED BASE API OVERRIDES */

  get db() {
    return `${this.dbPrefix}business_plans`;
  }

  get store() {
    return this.stores.businessPlansStore;
  }

  fromFirestore(res: DocumentData): BusinessPlanModel {
    return new BusinessPlanModel(this.stores, this.api, {
      uid: res.id,
      ...res.data(),
    });
  }
}
